import { render } from "./EmailMain.vue?vue&type=template&id=2e065db7"
import script from "./EmailMain.vue?vue&type=script&lang=js"
export * from "./EmailMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__